import "swiper/css";
import "swiper/css/free-mode";
import { FreeMode } from "swiper/modules";
import { Box, Stack, Theme } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";

import { CombinedEventCard } from "@/shared/common/EventCard/CombinedEventCard";

import { useAppSystem } from "@/global/hooks/useAppSystem";
import { isRegularEventsMinMaxSelectionReached } from "../utils.events";

import type { EventType } from "@/global/store/data/types";

interface Props {
  isLoading: boolean;
  events: EventType[];
  selectedEvents: EventType[];
  onLoad?: (e: any) => void;
  onSelect: (e: EventType) => void;
  onClickPreview?: (e: EventType) => void;
}

export function FeaturedGameSlider({
  events,
  selectedEvents,
  onLoad,
  onSelect,
  onClickPreview,
}: Props) {
  const { teamConfig, theme } = useAppSystem();
  const styles = useStyles(theme);

  const featuredEvents = events.filter((itm) => itm.isFeaturedGame);
  const shouldCenter = featuredEvents.length <= 2;

  return (
    <Stack direction={"column"}>
      <Box sx={styles.swiperWrapper(shouldCenter)}>
        <Swiper
          modules={[FreeMode]}
          style={styles.swiper}
          onInit={onLoad}
          spaceBetween={32}
          slidesPerView={"auto"}
          freeMode={true}
        >
          {featuredEvents
            .map((evt, idx) => {
              const isSelected = selectedEvents.some((ev) => {
                return ev.eventCode == evt.eventCode;
              });
              const { isMaxEventCountReached } =
                isRegularEventsMinMaxSelectionReached(
                  selectedEvents,
                  teamConfig
                );

              return (
                <SwiperSlide key={idx}>
                  <CombinedEventCard
                    cardVariant={"desktop-mobile-alternate"}
                    variant="featured"
                    event={evt}
                    isDisabled={isMaxEventCountReached && !isSelected}
                    isSelected={isSelected}
                    onSelect={() => {
                      onSelect(evt);
                    }}
                    onClickPreview={() => onClickPreview?.(evt)}
                    slot={{
                      wrapper: {
                        style: {
                          minWidth: "350px",
                          maxWidth:
                            teamConfig?.uiConfigs?.featuredGameCard
                              ?.eventCardMaxWidth || "unset",
                        },
                      },
                    }}
                  />
                </SwiperSlide>
              );
            })}
        </Swiper>
      </Box>
    </Stack>
  );
}

function useStyles(theme: Theme) {
  return {
    swiperWrapper: (shouldCenter: boolean) => ({
      userSelect: "none",
      "& .swiper-slide": {
        width: "fit-content !important",
      },

      ...(shouldCenter && {
        [theme.breakpoints.up("sm")]: {
          "& .swiper-wrapper": {
            justifyContent: "center",
          },
        },
      }),

      [theme.breakpoints.down("sm")]: {
        transformOrigin: "center",
        transform: "scale(0.9) translate(-16px, 0px) ",
      },
    }),

    swiper: {
      overflow: "visible",
      paddingBottom: "12px",
      //   paddingLeft: "20px",
    },
  };
}
